"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.replace");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactTextMask = _interopRequireDefault(require("react-text-mask"));

var _createNumberMask = _interopRequireDefault(require("text-mask-addons/dist/createNumberMask"));

var _Control = _interopRequireDefault(require("@icare/rhythm-form-react/lib/elements/Control"));

var _createAutoCorrectedCurrencyPipe = _interopRequireDefault(require("./createAutoCorrectedCurrencyPipe"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _autoId = 0;

var Currency = /*#__PURE__*/function (_React$Component) {
  _inherits(Currency, _React$Component);

  var _super = _createSuper(Currency);

  function Currency(props) {
    var _this;

    _classCallCheck(this, Currency);

    _this = _super.call(this, props);
    _this.mask = (0, _createNumberMask.default)({
      allowDecimal: props.allowDecimals
    });
    _this.pipe = (0, _createAutoCorrectedCurrencyPipe.default)();
    _autoId = _autoId + 1;
    return _this;
  }

  _createClass(Currency, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          error = _this$props.error,
          status = _this$props.status,
          statusMessage = _this$props.statusMessage,
          name = _this$props.name,
          required = _this$props.required,
          requiredText = _this$props.requiredText,
          id = _this$props.id,
          width = _this$props.width,
          helpText = _this$props.helpText,
          tooltip = _this$props.tooltip,
          tooltipProps = _this$props.tooltipProps,
          labelProps = _this$props.labelProps,
          label = _this$props.label,
          isInline = _this$props.isInline,
          className = _this$props.className,
          allowDecimals = _this$props.allowDecimals,
          value = _this$props.value,
          attr = _objectWithoutProperties(_this$props, ["error", "status", "statusMessage", "name", "required", "requiredText", "id", "width", "helpText", "tooltip", "tooltipProps", "labelProps", "label", "isInline", "className", "allowDecimals", "value"]);

      var _status = status;
      var _statusMessage = statusMessage;

      if (error) {
        _status = 'error';
        _statusMessage = error;
      }

      var isInvalid = _status === 'error';
      var inputClasses = (0, _classnames.default)('text-input', _defineProperty({}, "text-input--".concat(_status), !!_status));
      var inputId = id || name;
      var optionalInputAttributes = {};

      if (_statusMessage) {
        optionalInputAttributes['aria-describedby'] = "".concat(inputId, "-status-msg");
      }

      return /*#__PURE__*/_react.default.createElement(_Control.default, {
        className: className,
        name: inputId,
        isInline: isInline,
        label: label,
        labelProps: labelProps,
        tooltip: tooltip,
        tooltipProps: tooltipProps,
        helpText: helpText,
        required: required,
        requiredText: requiredText,
        width: width,
        status: _status,
        statusMessage: _statusMessage
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "currency__input-wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: inputClasses
      }, /*#__PURE__*/_react.default.createElement(_reactTextMask.default, _extends({
        id: inputId,
        mask: this.mask,
        pipe: this.pipe,
        placeholderChar: "-",
        guide: false,
        keepCharPositions: true,
        value: allowDecimals ? value || '' : value ? parseInt(value.replace(/[$,]/g, '')) : '',
        "aria-required": required,
        "aria-invalid": isInvalid
      }, optionalInputAttributes, attr)))));
    }
  }]);

  return Currency;
}(_react.default.Component);

exports.default = Currency;

_defineProperty(Currency, "propTypes", {
  error: _propTypes.default.node,
  status: _propTypes.default.oneOf(['error', 'warning', 'info', 'success']),
  name: _propTypes.default.string,
  statusMessage: _propTypes.default.string,
  value: _propTypes.default.string,
  allowDecimals: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  id: _propTypes.default.string,
  required: _propTypes.default.bool,
  requiredText: _propTypes.default.string,
  width: _propTypes.default.oneOf(['xl', 'l', 'm', 's', 'xs', 'xxs']),
  helpText: _propTypes.default.string,
  tooltip: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  tooltipProps: _propTypes.default.object,
  labelProps: _propTypes.default.object,
  label: _propTypes.default.string,
  isInline: _propTypes.default.bool,
  className: _propTypes.default.string
});

_defineProperty(Currency, "defaultProps", {
  error: null,
  statusMessage: null,
  status: null,
  value: null,
  name: null,
  allowDecimals: true,
  onChange: function onChange() {},
  id: "currency-".concat(_autoId),
  required: false,
  requiredText: null,
  helpText: null,
  width: null,
  tooltip: null,
  tooltipProps: {},
  label: null,
  labelProps: {},
  className: null,
  isInline: false
});
//# sourceMappingURL=Currency.js.map